import { type TagBasedOrderExclusion } from "@north-beam/nb-common";

export const TAG_TYPES: {
  value: TagBasedOrderExclusion["tagType"];
  label: string;
}[] = [
  { value: "order", label: "Order" },
  { value: "customer", label: "Customer" },
];

export const TAG_LOGIC: {
  value: TagBasedOrderExclusion["tagLogic"];
  label: string;
}[] = [
  { value: "is", label: "Exact match" },
  { value: "contains", label: "Contains" },
  { value: "starts_with", label: "Starts with" },
  { value: "ends_with", label: "Ends with" },
];
